const alphabeticSort = (a, b) => {
  const fa = a.name.toLowerCase();
  const fb = b.name.toLowerCase();
  if (fa < fb) { return -1; }
  if (fa > fb) { return 1; }
  return 0;
};

export default alphabeticSort;
